/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import { ImageInPageEditorV2 } from "cms/images/image-inpage-editor-v2";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap";
import { useState } from "react";

const BannerComponentEditor = () => {

    const { component, update, updateFactory } = useUpdateComponent();
    const richtext = component?.richtext;
    const _image = component?.image;
    const _settings = component?.settings;
    const onDarkBackground = component?.onDarkBackground ?? false;

    const [image, setImage] = useState(_image);
    const [settings, setSettings] = useState(_settings);

    const onChangeImageWithSettings = (_image, settings) => {
        const { guid } = _image || {};
        setImage(image);
        setSettings(settings);
        update("image", guid);
        update("settings", settings);
    };

    const onRemoveImage = () => {
        update("image", undefined);
    };

    const updateRichText = updateFactory("richtext");

    const updateOnDarkBackground = (event) => {
        update("onDarkBackground", event.target.checked);
    };

    return (
        <div className='simplicity-editor-frame'>
            <Typography variant='overline' color={"text.secondary"}>
                Content
            </Typography>
            <SimplicityComposerEnsureTipTap
                richtext={richtext}
                onChange={updateRichText}
            />

            <div className="banner-component-edit-checkbox-container">
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={onDarkBackground}
                            onChange={updateOnDarkBackground}
                        />
                    }
                    label="On dark background"
                />
            </div>

            <Typography variant='overline' color={"text.secondary"}>
                Image
            </Typography>

            <ImageInPageEditorV2
                image_guid={image}
                settings={settings}
                onChangeImageWithSettings={onChangeImageWithSettings}
                onRemoveImage={onRemoveImage}
            />
        </div>
    );
};

BannerComponentEditor.displayName = "BannerComponentEditor";
export { BannerComponentEditor };
